const stepNameList: Record<number, string> = {
  1: 'Personal information',
  2: 'Device Information',
  3: 'General Description',
};

export const getStepName = (t: (text: string) => void, stepNumber: number) => {
  return `${t('step')} ${stepNumber}: ${t(stepNameList[stepNumber])}`;
};
